<app-header-component
  class="box-shadow-bottom"
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding">
  <div class="privacy-content" *ngIf="useAccountContent">
    <p class="fs-4 font600 text-color">{{"privacy_policy.travelx_vip_privacy_policy" | translate}}</p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.travelx_vip_subscription_is_a_premium_airport_services" | translate}} &amp; {{"privacy_policy.travel_services_subscription_that_enables_members_to_save" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.travelx_vip_privacy_policy_privacy_policy_sets_out_what_information_travelx_collectively_we_us_the_parties_our_collect_and_how_we_use_it" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.this_privacy_policy_also_applies_when_you_redeem_travel_and_lifestyle_awards_from_partners_of_the_parties" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.partner_means_a_business_whom_either_travelx_has_made_arrangements_for_members_to_offer" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.in_this_travelx_vip_privacy_policy_privacy_policy" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.travelx_vip_website_our_website_refers_to_vip_travelx_ai_and_any_other_domain_as_may_be_adopted_by_travelx" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.travelx_vip_app_our_app_mobile_apps_mobile_applications_refers_to_travelx_vip_mobile_applications" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.data_refers_to_any_representation_of_information_including_an_expression_of_opinion_in_any_document_and_includes_a_personal_identifier" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.supplier_refers_to_any_individual_business_entity_or_professional_body_for_which_travelx_has_no_direct_ownership" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.in_this_privacy_policy_words_denoting_one_gender_shall_include_the_other_gender_and_the_neuter" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.in_this_privacy_policy_the_headings_and_captions_used_herein_are_inserted_for_convenience_of_reference" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.this_privacy_policy_sets_out_the_policies_and_practices_of_which_any_information_including_personal_data" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.all_non_english_versions_of_this_privacy_policy_are_translations_of_the_original_version_in_english" | translate}}
    </p>

    <p class="fs-2 font400 text-color">
      <b class="fs-3 font600 text-color">{{"privacy_policy.contents" | translate}}</b><br />
      {{"privacy_policy.collection_of_information" | translate}} <br />
      {{"privacy_policy.cookies" | translate}} <br />
      {{"privacy_policy.retention_of_personal_data" | translate}} <br />
      {{"privacy_policy.purposes_for_collection_and_use_of_personal_data" | translate}} <br />
      {{"privacy_policy.disclosure_of_personal_data" | translate}} <br />
      {{"privacy_policy.consent" | translate}} <br />
      {{"privacy_policy.access_rights" | translate}} <br />
      {{"privacy_policy.changes_to_privacy_policy" | translate}}<br />
      {{"privacy_policy.contact" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.collection_of_Information" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.we_will_request_you_to_provide_the_following_data_for_our_collection_and_process" | translate}}
    </p>

    <ul>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.information_and_or_data_collected_from_the_reservation_processes_for_the_purpose_of_completing_the_reservation" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.information_and_or_data_collected_when_you_check_in_the_hotel_for_the_purpose_of_verifying_your_identities" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.information_and_or_data_collected_during_your_stay_at_a_hotel_for_the_purpose_of_complying_our_financial_reporting" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.information_and_or_data_collected_from_you_when_you_set_up_an_account_with_us_including_but_not_limited_to_name" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.survey_and_research_information_collected_from_you_by_online_or_offline_channels" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.device_and_usage_information_about_your_browser_or_device_including_the_type_of_device_you_are_using_your_browser_and_operating_system" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.location_information_about_the_location_of_your_device_such_as_information_that_identifies_your_device_s_precise_location_eg_gps_latitude_and_longitude" | translate}}
      </li>
    </ul>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.supply_of_information_or_personal_data_to_us_is_non_obligatory_except_that_certain_personal_data_is_required_to_be_provided_by_local_laws_you_may" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.2_cookies" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.cookies_are_used_on_all_online_tools_available_to_you_including_without_limitation_the_travelx_vip_website_to_distinguish_you_from_other_online" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_should_understand_that_while_cookies_in_general_do_not_tell_us_your_email_address_or_other_personal_data_however" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.in_addition_to_the_information_we_collect_through_cookies_we_also_collect_behavioral_data_and_store_such_data_for_analytical" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.the_use_of_any_information_we_collected_either_through_the_use_of_cookies_or_otherwise" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.most_web_browsers_are_initially_set_up_to_accept_cookies_you_may_choose_to_edit_your_browser_options" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.please_take_note_that_cookies_from_third_parties_unaffiliated_with_travelx_or_our_business_partners_may_be" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.3_retention_of_personal_data" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.data_provided_by_you_will_be_retained_for_such_period_as_may_be_necessary_for_carrying_out_the_purposes_stated" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.data_collected_by_us_in_order_to_carry_out_the_purposes_or_directly_related_purposes_stated_in_this_privacy_policy" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.the_databases_managed_by_us_may_also_include_guest_passport_number_or_government_id_if_such_is_required" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.all_personal_data_stored_in_our_databases_are_encrypted_and_treated_as_confidential_information" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.we_may_also_store_other_information_such_as_your_special_requests_food_and_beverage_preferences_and_transaction" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.as_we_operate_some_of_the_services_as_well_as_a_variety_of_international_airport_services_in_various_countries" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.4_purposes_for_Collection_and_Use_of_Personal_Data" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.the_purposes_for_which_your_data_may_be_and_or_is_used_by_us_include_without_limitation" | translate}}
    </p>
    <ul>
      <li class="fs-2 font400 text-color">{{"privacy_policy.to_process_and_administer_your_room_reservation_application" | translate}}</li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_fulfill_and_process_requests_submitted_by_you_for_any_services_offered_by_us" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_provide_and_maintain_travelx_vip_website_and_mobile_applications_or_any_of_our_other" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_improve_the_travelx_vip_website_mobile_applications_and_your_account_with_us_including_without_limitation" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_compile_and_provide_anonymous_statistics_about_users_of_the_travelx_vip_website_and_mobile_applications_and_provide" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_provide_and_or_market_the_goods_and_or_services_provided_by_us_and_or_our_affiliated" | translate}}
      </li>
      <li class="fs-2 font400 text-color">{{"privacy_policy.to_manage_the_relationship_between_you_and_travelx" | translate}}</li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_facilitate_our_business_operations_across_our_group_of_companies_including_the_fulfillment" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.to_evaluate_develop_offer_and_promote_goods_and_or_services_provided" | translate}}
      </li>
    </ul>

    <p class="fs-2 font400 text-color">
      {{"privacy_policy.we_will_not_use_your_personal_data_to_conduct_direct_marketing_via_email_push_message_direct_mail_telephone_fax" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.if_you_agree_to_the_above_direct_marketing_use_your_personal_data_held_by_us_may_be_shared_within_travelx" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.your_consent_to_the_use_of_your_personal_data_for_the_direct_marketing_use_as_indicated" | translate}}
    </p>

    <ul>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.you_may_indicate_your_consent_to_the_above_by_the_following_ways_ticking_the_box_es_indicating_your_consent" | translate}}
      </li>
      <li class="fs-2 font400 text-color">
        {{"privacy_policy.you_may_opt_out_from_receiving_marketing_communications_at_any_time_free_of_charge_by_the_following" | translate}}
      </li>
    </ul>

    <b class="fs-3 font600 text-color">{{"privacy_policy.5_disclosure_of_personal_data" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.if_you_have_registered_a_member_account_with_us_you_hold_the_sole_responsibility_of_safeguarding_your_own_login_and_password" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_acknowledge_and_understand_that_the_transmission_of_information_via_the_internet_is_not_completely_secure" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_authorize_us_to_use_and_share_personal_data_provided_by_you_within_travelx_and_its_affiliated_businesses" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_agree_to_update_your_own_personal_data_from_time_to_time_so_that_it_remains_accurate" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_authorize_our_suppliers_to_disclose_your_personal_data_registered_with_such_suppliers" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_understand_that_it_is_an_inherent_part_of_our_business_to_provide_you_quality_services_and_facilities_owned" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.6_consent" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.by_using_services_provided_by_us_and_or_the_travelx_vip_website_or_by_providing_any_personal_data_to_us_via_registering" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.7_access_rights" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_may_request_to_access_and_to_correct_your_personal_data_held_by_us_if_you_wish_to_obtain_a_copy_of_any_of_such_personal_data" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.a_request_for_access_or_correction_to_or_deletion_of_personal_data_or_to_obtain_a_copy" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.if_at_any_time_you_wish_to_withdraw_your_consent_to_be_bound_by_the_privacy_policy_or_do_not_wish_to_remain_a_subscriber" | translate}}
    </p>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.all_data_privacy_is_handled_in_accordance_with_the_ordinance_in_effect_should_any_provision_of_this_privacy_policy" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.8_changes_to_privacy_policy" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_accept_and_agree_that_we_shall_have_the_sole_discretion_to_amend_this_privacy_policy_upon_reasonable_notice" | translate}}
    </p>

    <b class="fs-3 font600 text-color">{{"privacy_policy.9_contact" | translate}}</b>
    <p class="fs-2 font400 text-color">
      {{"privacy_policy.you_may_visit_us_on_www_vip_travelx_ai_or_contact_us_in_writing_attention_to_data_protection_officer" | translate}}
    </p>
  </div>

  <div class="privacy-content" *ngIf="!useAccountContent">
    <p class="fs-4 font600 text-color">{{
      "privacy_policy.privacy_policy" | translate
    }}</p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_1_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_1_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_2_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_2_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_3_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_3_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_4_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_4_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_5_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_5_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_6_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_6_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_7_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_7_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_8_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_8_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_9_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_9_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_10_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_10_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_11_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_11_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_12_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_12_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_13_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_13_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_14_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_14_content' | translate"></p>

    <b class="fs-3 font600 text-color">{{ "privacy_policy.section_15_title" | translate }}</b>
    <p class="fs-2 font400 text-color" [innerHTML]="'privacy_policy.section_15_content' | translate"></p>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-button
      expand="block"
      class="primary-btn ion-margin fs-3 font500"
      mode="ios"
      (click)="closeModal()"
    >
      {{ "Close" | translate }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
